import { ReactNode } from 'react';

export interface BoneLink {
  href?: string;
  icon?: ReactNode;
  label: string;
  openBlank?: boolean;
  onClick?: () => any;
  disabled?: boolean;
  tooltip?: string;
  selected?: boolean;
}

export enum AppName {
  Authors = 'Authors',
  Card = 'Encart',
  Crud = 'Crud',
  Diapo = 'Diapo',
  Newsletter = 'Newsletter',
  Page = 'Pages',
  People = 'People',
  Photo = 'Photos',
  Recipe = 'Recipe',
  Story = 'Story',
  Video = 'Video',
  Web = 'Web',
  Dashboard = 'Dashboard',
  Orphans = 'Pages Indépendantes',
  Tags = 'Tags',
}

export type AppUrls = {
  [key in AppName]?: string;
};
